<template>
  <!-- wrapper(s) -->
  <div class="wrapper">
    <Header class="header" :val="headerTitle"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content">
        <div class="boxMsg bg02">
          <p>
            명의변경을 위해서는 사전에 양도인과 양수인간 협의가 완료된 상태여야 하며, 명의변경신청 완료시 전문상담원이 양도인,양수인 양측과 통화하여
            진행됩니다.
            <br />
            명의변경은 렌탈제품만 가능하며 신용등급에 따라 명의변경이 불가할 수 있습니다.
          </p>
        </div>

        <section>
          <div class="titArea">
            <h2 class="titH4">명의 변경 정보 선택</h2>
          </div>

          <div class="formArea">
            <span class="label">상품선택</span>
            <select class="ipt" title="상품선택 선택" v-on:input="productChange($event.target.value)" v-model="orderId">
              <option value="" disabled="disabled" selected="selected">선택</option>
              <option v-for="serviceAuthOwnershipProduct in serviceAuthOwnershipProductList" :value="serviceAuthOwnershipProduct.orderId">
                {{ serviceAuthOwnershipProduct.orderId }} {{ serviceAuthOwnershipProduct.productName }}
              </option>
            </select>

            <span class="label">명의변경 희망일</span>
            <div class="setHalf">
              <!--<input type="text" id="ipt2_3" class="ipt date" title="날짜 선택" value="2017-04-20">-->
              <datepicker
                v-model="hopeDate"
                v-bind:format="format"
                v-bind:input-class="inputClass"
                v-bind:language="lang"
                :disabled-dates="hopeDisalbledDate"
              ></datepicker>
            </div>
          </div>

          <div class="orderSum">
            <ul class="infoList">
              <li>
                <span class="item">결제금액(예상)</span>
                <span class="val">{{ balAmt | currency }}원</span>
              </li>
              <li>
                <span class="item">납부회차</span>
                <span class="val">{{ tims | currency }}회차</span>
              </li>
              <li>
                <span class="item pointC4"><em>월 렌탈료</em></span>
                <span class="val pointC4">
                  <span class="money">
                    <em>{{ rentalAmt | currency }}</em>
                    원
                  </span>
                </span>
              </li>
            </ul>
          </div>
        </section>

        <section class="hr">
          <div class="titArea">
            <h2 class="titH4">양수인 정보 입력</h2>
          </div>

          <div class="formArea">
            <span class="label">양수인 이름</span>
            <input type="text" class="ipt" title="이름 입력" value="" placeholder="양수인 이름을 입력해주세요" v-model="asgeNm" />

            <span class="label">양수인 연락처</span>
            <input type="tel" class="ipt" title="연락처 입력" value="" placeholder="' - ' 없이 입력해주세요." v-model="asgeNum" v-onlyNum />
            <p class="fieldMsg error" id="idMsg" v-if="invalidInfo && (asgeNm == '' || asgeNum == '')">양수인 정보를 누락없이 기입해주세요.</p>

            <span class="singleIpt">
              <input type="checkbox" class="ipt" name="agree" id="agree" v-model="agreeCheck" />
              <label for="agree">본인(양도인)은 명의 변경과 관련하여양수인 정보 입력에 대해 사전 협의 및 동의를 얻었습니다.</label>
            </span>
            <p class="fieldMsg error" id="agreeText" v-if="invalidAgree && !agreeCheck">동의 해주세요.</p>
          </div>
        </section>

        <div class="btnArea sticky">
          <button type="button" class="btn_p" @click="goTransfer()" :disabled="regButtonShow">신청</button>
        </div>

        <MessagePop v-if="messagePop" @close="close">
          <p v-html="msg"></p>
        </MessagePop>
      </div>
      <!-- content(e) -->
    </div>
    <!-- container(e) -->
    <footer class="footer"></footer>
  </div>
  <!-- wrapper(e) -->
</template>

<script>
import * as customjs from '@/../static/js/m.front.js';
// import * as customjs from '../../../../static/js/m.front.js';
import { isEmpty } from '@/common/common.function';
import ApiService from '@/common/api.service';
import JwtService from '@/common/jwt.service';
import { ko } from 'vuejs-datepicker/dist/locale';
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';
import MessagePop from '@/components/popup/MessagePop';

export default {
  name: 'changeAccount',
  components: {
    Datepicker,
    MessagePop,
  },
  data: function() {
    return {
      headerTitle: '명의 변경 신청',
      regButtonShow: true,

      userInfo: JwtService.getUserInfo(),
      messagePop: false,
      serviceAuthOwnershipProductList: [],
      orderId: '',
      balAmt: '0', // 결제금액 (예상)
      rentalAmt: '0', // 원렌탈료
      tims: '0', // 납부회차
      asgeNm: '', // 양수인 이름
      asgeNum: '', // 양수인 연락처

      format: 'yyyy-MM-dd',
      inputClass: 'ipt date notDel uiAct hasDatepicker',
      calendarClass: 'ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all',
      lang: ko,
      hopeDate: '', // 명의변경 희망일
      hopeDisalbledDate: {
        to: new Date(),
        days: [6, 0],
      },
      completeChange: false,
      invalidInfo: false,
      invalidAgree: false,
      agreeCheck: false,
    };
  },
  mounted() {
    this.defaultDate();

    this.selectServiceAuthOwnershipProducts();
  },
  watch: {
    orderId() {
      this.selectServiceAuthOwnershipBalInfo();
      this.checkButton();
    },
    hopeDate() {
      // console.log("==2");
      // console.log(this.hopeDate);
      this.selectServiceAuthOwnershipBalInfo();
      this.checkButton();
    },
    asgeNm() {
      this.checkButton();
    },
    asgeNum() {
      this.checkButton();
    },
    agreeCheck() {
      this.checkButton();
    },
  },
  methods: {
    checkButton: function() {
      if (isEmpty(this.orderId)) {
        this.regButtonShow = true;
        return false;
      }
      if (isEmpty(this.asgeNm)) {
        this.regButtonShow = true;
        return false;
      }
      if (isEmpty(this.asgeNum)) {
        this.regButtonShow = true;
        return false;
      }

      if (!this.agreeCheck) {
        this.regButtonShow = true;
        return false;
      }
      this.regButtonShow = false;
    },
    defaultDate() {
      // let today = new Date();
      // today.setDate(today.getDate() + 7);
      // this.hopeDate = today;
      //
      // this.installReqDate2 = today.getFullYear() + '-' + this.numberPad((today.getMonth() + 1), 2) + '-' + this.numberPad(today.getDate(), 2);
    },
    selectServiceAuthOwnershipProducts() {
      ApiService.service('GET', '/service/auth/ownership/products', '')
        .then(({ data }) => {
          console.log(data);
          this.serviceAuthOwnershipProductList = data.result;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    selectServiceAuthOwnershipBalInfo() {
      if (this.orderId != '' && this.hopeDate != '') {
        ApiService.service('GET', '/service/auth/ownership/balInfo/' + this.orderId + '/' + moment(this.hopeDate).format('yyyyMMDD'), '')
          .then(({ data }) => {
            console.log(data);
            this.balAmt = data.result.balAmt;
            this.rentalAmt = data.result.rentalAmt;
            this.tims = data.result.tims;
          })
          .catch(({ response }) => {
            console.log(response);
          });
      }
    },
    productChange: function(value) {
      this.orderId = value;
    },
    validate: function() {
      this.invalidInfo = false;
      this.invalidAgree = false;
      if (isEmpty(this.orderId)) {
        this.msg = '상품을 선택해주세요.';
        this.messagePop = true;
        return false;
      }
      if (isEmpty(this.asgeNm)) {
        this.msg = '양수인 정보를 누락없이 기입해주세요.';
        this.messagePop = true;
        this.invalidInfo = true;
        return false;
      }
      if (isEmpty(this.asgeNum)) {
        this.msg = '양수인 정보를 누락없이 기입해주세요.';
        this.messagePop = true;
        this.invalidInfo = true;
        return false;
      }

      if (!this.agreeCheck) {
        this.msg = '동의 해주세요.';
        this.messagePop = true;
        this.invalidAgree = true;
        return false;
      }

      return true;
    },
    goTransfer() {
      if (!this.validate()) {
        return;
      }

      let reqParam = {
        request: {
          asgeNm: this.asgeNm,
          asgeNum: this.asgeNum,
          orderId: this.orderId,
          stndDt: moment(this.hopeDate).format('yyyyMMDD'),
          userId: this.userInfo.userId,
        },
      };

      ApiService.service('POST', '/service/auth/ownership/transfer', reqParam)
        .then(({ data }) => {
          console.log(data);
          if (data.isSucceed) {
            const params = {};
            // //const appsFlyerParams = JSON.stringify(params);
            window.appsFlyer('af_complete_transfer_application', params);
            this.msg = '명의변경 신청접수가<br> 완료되었습니다. 상담원이<br> 순차적으로 전화드릴 예정입니다.';
            this.messagePop = true;
            this.completeChange = true;
          } else {
            this.msg = data.error;
            this.messagePop = true;
          }
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
        });
    },
    close() {
      this.messagePop = false;
      if (this.completeChange) {
        this.$router.push('/myPage');
      }
    },
  },
};
</script>
